const COPY_SLOTS = 4;

const participantKind = participant =>
  participant?.kind || participant?.party_kind || '';

const participantRole = participant =>
  participant?.role || participant?.party_role || '';

export const isEditableRecipient = participant =>
  participantKind(participant) === 'pessoa_fisica';

export const normalizeDeliveryCopies = copies =>
  Array.from({ length: COPY_SLOTS }, (_, index) => {
    const copy = Array.isArray(copies) ? copies[index] || {} : {};
    return {
      id: copy.id || '',
      name: copy.name || '',
      email: copy.email || '',
    };
  });

export const groupDeliveryRecipients = participants => {
  const values = Array.isArray(participants) ? participants : [];
  const representatives = values.filter(
    participant => participant.relation_type === 'representante'
  );
  const representativesByParent = representatives.reduce(
    (groups, participant) => {
      const key = String(participant.parent_party_id || '');
      groups[key] = [...(groups[key] || []), participant];
      return groups;
    },
    {}
  );

  return ['vendedor', 'comprador'].map(role => {
    const principals = values.filter(
      participant =>
        participantRole(participant) === role &&
        participant.relation_type !== 'representante'
    );

    return {
      role,
      physicalCount: principals.filter(
        participant => participantKind(participant) === 'pessoa_fisica'
      ).length,
      companyCount: principals.filter(
        participant => participantKind(participant) === 'pessoa_juridica'
      ).length,
      participants: principals.map(participant => ({
        ...participant,
        representatives: representativesByParent[String(participant.id)] || [],
      })),
    };
  });
};

export const deliveryParticipantEmailsValid = participants =>
  (Array.isArray(participants) ? participants : [])
    .filter(isEditableRecipient)
    .every(participant =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(participant.email || '')
    );
